import React from "react";
import { Autocomplete } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { TriagedFilterOption } from "../../../common";
import styles from "./endpointFilter.module.scss";
const EndpointFilter = ({ value, endpoints, loading, className, onChange, onOpen, }) => {
    return (React.createElement(Autocomplete, { id: "endpoints-filter", label: "Filter by endpoint", className: className, loading: loading, isClearAlwaysVisible: value !== "", freeSolo: true, value: value, options: endpoints.map((endpoint) => endpoint.label), onChange: (_event, value) => { var _a; return onChange((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : ""); }, onOpen: onOpen, renderOption: (props, option) => {
            const endpoint = endpoints.find((endpoint) => endpoint.label === option);
            if (!endpoint) {
                return;
            }
            return (React.createElement("li", { ...props, key: option, className: getClassName(props.className, styles["endpoint-filter-menu-item"]) },
                React.createElement("div", { className: styles["endpoint-filter-row"] },
                    React.createElement("div", { className: styles["endpoint-filter-menu-item-option"] },
                        React.createElement("div", null, option),
                        endpoint.location && (React.createElement("div", { className: styles["endpoint-filter-menu-item-location"] }, endpoint.location))),
                    React.createElement(TriagedFilterOption, { triaged: !endpoint.exposed }))));
        } }));
};
export default EndpointFilter;
//# sourceMappingURL=EndpointFilter.js.map